import { useState, useCallback } from 'react';

export const useShiftModals = () => {
  // Modal state
  const [openNextShiftModal, setOpenNextShiftModal] = useState(false);
  const [selectedShift, setSelectedShift] = useState(null);

  // Modal handlers
  const handleOpenNextShiftModal = useCallback((shift) => {
    setSelectedShift(shift);
    setOpenNextShiftModal(true);
  }, []);

  const handleCloseNextShiftModal = useCallback(() => {
    setOpenNextShiftModal(false);
    setSelectedShift(null);
  }, []);

  return {
    // Modal state
    openNextShiftModal,
    selectedShift,
    // Modal handlers
    handleOpenNextShiftModal,
    handleCloseNextShiftModal,
  };
};
